type Env = "staging" | "production";
type ENV_NAME = "staging" | "production";

const getEnv = (): Env => {
  switch (import.meta.env.REACT_APP_ENV_NAME) {
    case "production":
    case "staging":
      return import.meta.env.REACT_APP_ENV_NAME as ENV_NAME;
    default:
      return "staging";
  }
};

export type { Env };
export { getEnv };
